<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Consolidated Picking List {{picklist_ref}}</strong>
                    </div>
                    <b-row>
                        <b-col sm="4">
                            <label>Picking List No</label>
                            <b-form-input type="text" v-model="pList.picklist_num" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                            <label>Picking List Date</label>
                                <b-form-input type="text" v-model="pList.picklist_date" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                            <label>Location From ( Warehouse )</label>
                                <b-form-input type="text" v-model="pList.from_location_id" disabled></b-form-input>
                        </b-col>
                    </b-row>
                    <br/><br/>
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive">
                                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="picking_list_items_fields" :items="pList.picklist_items">
                                </b-table>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="(dosLength*1) > 0">
                        <b-col sm="12">
                            <label><strong>Delivery Orders</strong></label>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="2" v-for="d in pList.dos">
                            <b-button type="submit" size = "lg" variant="secondary" @click ="printDO(d)" class="btn btn-block">{{d.do_num}}</b-button>
                            <br/>
                        </b-col>
                    </b-row>
                    <div slot="footer">
                        <b-row>
                            <b-col sm="2" v-if="showPickListHeader == false">
                                <b-button type="submit" size = "lg" variant="success" @click ="printWithoutConsolidatedPickList">Print Picking List</b-button>
                            </b-col>
                            <b-col sm="2" v-if="showPickListHeader == true">
                                    <b-button type="submit" size = "lg" variant="success" @click ="printWithConsolidatedPickList">Print Picking List</b-button>
                            </b-col>
                            <b-col sm="4">
                                <label>Print Consolidated Picking List</label>&nbsp;&nbsp;
                                    <toggle-button v-model="showPickListHeader" :sync="true" :labels="true" :height="29" :width="58"/>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <br/><br/>
        <b-row>
            <b-col sm="12">
                <b-card v-for="data in pList.packlists">
                    <div slot="header">
                        <strong>{{data.delivery_method_name}}</strong>
                        <span style="float:right"><strong>{{data.member_full}}</strong></span>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label>Sales Doc Nos.</label>
                                    <b-form-input type="text" v-model="data.invoice_num_list" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm = "12">
                            <b-form-group>
                                <label>Invoices No</label>
                                    <b-form-input type="text" v-model="data.tax_invoices_nums" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="data.delivery_method_name =='DELIVERY'">
                        <b-col sm="12">
                            <b-form-group>
                                <label>Delivery Address</label>
                                    <textarea class="form-control" rows="5" v-model="data.delivery_address" disabled></textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>  
                    <b-row v-if="data.delivery_method_name =='SELF PICK-UP'">
                            <b-col sm="12">
                                <b-form-group>
                                    <label>Pickup Location</label>
                                        <b-form-input type="text" v-model="data.from_location_id" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>                   
                    <b-row>
                        <b-col sm="3" v-if="data.delivery_method_name == 'DELIVERY'">
                            <b-form-group>
                                <label for="reson">Courier Company</label>
                                    <b-form-select id="courier" v-model="data.courier_company" :plain="true" :options="courier_list"></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group >
                                <label>Delivery Number</label>
                                    <b-form-input type="text" v-model="data.delivery_number"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label>Remarks</label>
                                    <textarea class="form-control" rows="3" v-model="data.remarks"></textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>                    
                    <b-row>
                        <b-col sm="12">
                            <div class="btn pull-right">
                                <b-button type="submit" size = "lg" variant="primary" @click ="packAll(data.items)" v-if="!data.isCompleted">Pack All</b-button>&nbsp;
                                <b-button type="submit" size = "lg" variant="danger" @click ="clearAll(data.items)" v-if="!data.isCompleted">Clear</b-button>
                            </div>
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col sm="12">
                            <div class="table-responsive">
                                <table class='table'>
                                    <thead>
                                        <th width="10px">S/N</th>
                                        <th width="150px">Product Code</th>
                                        <th style="min-width:300px">Product Name</th>
                                        <th width="150px">Qty</th>
                                        <th width="150px">Qty Delivered</th>
                                        <th width="180px">Qty Balance</th>
                                        <th width="180px">Qty Allocate</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row,index in data.items" v-bind:style= "[((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) > 0 ? {color:activeColor, fontWeight:'bold'} :'',((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) == 0 ? {color:otherColor} :'',(((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) < (row.qty * 1) && ((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) > 0 )? {color:'green',fontWeight:'bold'} :'']">
                                            <td>{{(index*1) +1}}</td>
                                            <td>{{row.product_code}}</td>
                                            <td>{{row.product_name}}</td>
                                            <td>{{row.qty}}</td>
                                            <td>{{row.qty_delivered}}</td>
                                            <td>{{(row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)}}</td>
                                            <td><input type="number" v-model="row.qty_allocated" class="form-control" min="1" @change="computePickingListQty(row)" @focus="getValue(row)" v-if="(row.qty_delivered*1) != (row.qty*1)"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row style="padding: 0px 0px 20px 18px;">
            <b-col sm="12">
                    <b-button type="submit" size="lg" variant="primary" @click="confirmGenerateDO" :disabled="showGenerateDo">Generate DO</b-button>
                    &nbsp;&nbsp;
                <b-button type="submit" size = "lg" variant="danger" @click ="back">Back</b-button>
            </b-col>
        </b-row>
        <div>
            <b-modal v-model="modalShow" @ok="generateDO" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                <p style="color:darkblue">Confirmed Generate DO?</p>
            </b-modal>
            <b-modal ref="myModalRef" hide-header-close hide-footer title="Delivery Order" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                <div class="d-block text-center">
                    <p>Delivery Order(s)<strong style="color:green"> {{DoNum}}</strong> has been generated.<br/><br/></p>
                </div>
                    <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
            </b-modal>
            <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p style="color:red">{{errorMessage}}</p>
                    </div>
                        <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
            </b-modal>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import warehouseLookup from '@/components/Autocomplete.vue'
import countryLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import {authHeader, apiWarehouseLookup, apiLocationProductUrl,apiCountryLookup,apiWsiGet,apiPicklistGet,apiGenerateDO, apiCourierLists} from '@/functions/common.vue'
import spinner from '@/components/Spinner.vue'
import cSwitch from '../../components/Switch'
import ToggleButton from 'vue-js-toggle-button'
import Vue from 'vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};

Vue.use(ToggleButton)

export default
{
    components:{spinner,cSwitch},
    props: 
    {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    created()
    {
        this.picklist_ref = this.$route.params.picklistNum
        this.getPickingList()
        axios.post(apiCourierLists, {},authHeader())
                .then (res => {
                    if(res.data.code == 1)
                    {
                      this.courier_list = res.data.data
                    }
                })
                .catch(error => alert(error))
    },
    data()
    {
        return {
            showPickListHeader:false,
            font:'ukai',
            DoNum:'',
            activeColor: 'red',
            otherColor:'grey',
            title : "Picking List Details",
            modalShow:false,
            old_value:0,
            dosLength:'',
            errorMessage:'',
            qty_picked:0,
            prev_allocated_qty:0,
            loading:false,
            lockEntry : false,
            picklist_ref:'',
            showGenerateDo:true,
            pList:{},
            pickList_items:[],
            updateList:{},
            packItems :[],
            dos:[],
            picking_list_items_fields:
            [
                {key: 'product_code', label: 'Product Code'},
                {key: 'product_name', label: 'Product Name'},
                {key: 'qty', label: 'Qty'},
                {key: 'qty_picked', label: 'Qty Picked'},
                {key: 'qty_balance',label:'Qty Balance'}
            ],
            picking_list:{},
            courier_list:[],
        }
    },
    methods:
    {
        getPickingList()
        {
            this.loading = true
            axios.post(apiPicklistGet, {picklist_num:this.picklist_ref},authHeader())
            .then (res => 
            { 
                this.pList = res.data.data
                var pDate = new Date(this.pList.picklist_date)
                this.pList.picklist_date = "" + (pDate.getDate() > 9 ? '' : '0') + pDate.getDate() + '/'+  ((pDate.getMonth() + 1) > 9 ? '' : '0') + (pDate.getMonth() + 1) + '/' + pDate.getFullYear()+" " + (pDate.getHours() > 9 ? '' : '0') + pDate.getHours() + ":" + (pDate.getMinutes() > 9 ? '' : '0') + pDate.getMinutes() + ":" + (pDate.getSeconds() > 9 ? '' : '0') + pDate.getSeconds()
                var data = this.pList.packlists
                this.dosLength = res.data.data.dos.lengths
                var totalQty = 0
                var total = 0
                var dos = res.data.data.dos
                var sales_invoices = JSON.parse(this.pList.sales_invoices_num)
            
                var consignments = []
                var sales_docs = []
                var consignment_nums = ''
                var sales_invoice_nums = ''

                for (var d in sales_invoices)
                {
                    var document_start_char = sales_invoices[d].substring(0, 2);

                    if (document_start_char == "CN")
                    {
                        // Consignments
                        consignments.push(sales_invoices[d])
                    }
                    else
                    {
                        // Sales Invoices
                        sales_docs.push(sales_invoices[d])
                    }

                }


                for(var c in consignments)
                {
                    if(consignments[c] != consignments[consignments.length-1])
                    {
                        consignment_nums = consignment_nums + consignments[c] + ' / '
                    }
                    else
                    {
                        consignment_nums = consignment_nums + consignments[c]
                    }                     
                }

                for(var s in sales_docs)
                {
                    if(sales_docs[s] != sales_docs[sales_docs.length-1])
                    {
                        sales_invoice_nums = sales_invoice_nums + sales_docs[s] + ' / '
                    }
                    else
                    {
                        sales_invoice_nums = sales_invoice_nums + sales_docs[s]
                    }                     
                }
                this.pList.consignment_nums = consignment_nums
                this.pList.sales_invoice_nums = sales_invoice_nums

                var tax_invoices_num = JSON.parse(this.pList.tax_invoices_num)
                var p_tax_invoices_num = ''
                
                for(var t in tax_invoices_num)
                {
                    if(tax_invoices_num[t] != tax_invoices_num[tax_invoices_num.length-1])
                    {
                        p_tax_invoices_num = p_tax_invoices_num + tax_invoices_num[t] + ' / '
                    }
                    else
                    {
                        p_tax_invoices_num = p_tax_invoices_num + tax_invoices_num[t]
                    }                     
                }
                this.pList.tax_invoices_nums = p_tax_invoices_num

                for(let i in dos)
                {
                    var item = dos[i]
                    var doDate = dos[i].do_date
                    if(doDate != null)
                    {
                        doDate = new Date(doDate)
                        doDate  = "" + (doDate.getDate() > 9 ? '' : '0') + doDate.getDate() + '/'+  ((doDate.getMonth() + 1) > 9 ? '' : '0') + (doDate.getMonth() + 1) + '/' + doDate.getFullYear()
                    }
                    else
                    {
                        doDate = '-'
                    }
                    dos[i].do_date = doDate
                    if(item.country_id != null)
                    {
                                           
                        if(item.country_id == 'TH')
                        {
                            this.font = 'Garuda'
                        }
                        else if(item.country_id == 'KH')
                        {
                            this.font = 'Hanumanb'
                        }
                        axios.get(apiCountryLookup, {params: {q: item.country_id}})
                        .then(response => 
                        {
                
                            if (response.data != null)
                            {
                                var list = response.data.data.list
                                var item = list[0]
                                var country_name = item.country_name
                                country_name = country_name.toUpperCase()
                                dos[i].country_name = country_name
                            }
                        })
                    }
                }
                for(let key in data)
                {
                    var member_id = data[key].old_member_id
                    var member_name = data[key].member_name
                    var member_full = member_id + " - " + member_name
                    var invoice_nums =""
                    var invoice_num_list = data[key].invoice_nums_list
                    var tax_invoice_nums_list = JSON.parse(data[key].tax_invoice_nums_list)
                    var tax_invoices_nums = ""
        
                    for (let d in invoice_num_list)
                    {
                        if(invoice_num_list[d] != invoice_num_list[invoice_num_list.length-1])
                        {
                            invoice_nums = invoice_nums + invoice_num_list[d] + ' / '
                        }
                        else
                        {
                            invoice_nums = invoice_nums + invoice_num_list[d]
                        }
                    }

                                
                    for (let t in tax_invoice_nums_list)
                    {
                            if(tax_invoice_nums_list[t] != tax_invoice_nums_list[tax_invoice_nums_list.length-1])
                            {
                                tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t] + ' / '
                            }
                            else
                            {
                                tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t]
                            }
                    }

                        data[key].tax_invoices_nums = tax_invoices_nums
                        data[key].invoice_num_list = invoice_nums

                        data[key].member_full = member_full
                        if(data[key].delivery_address == null)
                        {
                            data[key].delivery_address = ''
                        } 
                        var items = data[key].items
                        for(let k in items)
                        {
                           items[k].qty = items[k].qty*1
                           items[k].qty_delivered = items[k].qty_delivered *1
                           var qtyBalance = (items[k].qty - items[k].qty_delivered)
                           totalQty = totalQty + qtyBalance
                           total = totalQty + qtyBalance
                        }
                        if(total > 0)
                        {
                            data[key].isCompleted = false
                        }
                        else
                        {
                            data[key].isCompleted = true
                        }
                }
                if (totalQty > 0)
                {
                    this.showGenerateDo = false
                }
                this.loading = false
            })
            .catch(error => alert(error))
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        packAll(items)
        {
            for (let k in items)
            {
                items[k].qty = items[k].qty * 1
                items[k].qty_delivered = items[k].qty_delivered * 1
                items[k].qty_allocated = items[k].qty_allocated * 1

                if(items[k].qty != items[k].qty_delivered)
                {
                    items[k].qty_allocated = items[k].qty - items[k].qty_delivered
                    //console.log(this.updateList)
                }

                this.computePickingListQty(items[k])
            }
        },
        clearAll(items)
        {
            for (let k in items)
            {
                if((items[k].qty*1)!= (items[k].qty_delivered*1))
                {
                    items[k].qty_allocated = 0
                }
                this.computePickingListQty(items[k])
            }
        },
        getValue(row)
        {
            this.old_value = row.qty_allocated
        },
        back()
        {
            this.$router.push({name: 'Stock Issuance (SI)'})
        },
        computePickingListQty(row)
        {
            row.qty = row.qty * 1
            row.qty_delivered = row.qty_delivered * 1
            row.qty_allocated = row.qty_allocated * 1
            
            if (row.qty_allocated < 0)
            {
                row.qty_allocated = 0
            }
            if (row.qty_allocated > row.qty - row.qty_delivered)
            {
                row.qty_allocated = 0
            }

           for (let key in this.pList.picklist_items)
            {
                this.pList.picklist_items[key].qty_picked = 0
            }
           axios.post(apiPicklistGet, {picklist_num:this.picklist_ref},authHeader())
            .then (res => 
            { 
                var data = res.data.data.picklist_items
                for(var d in data)
                {
                    
                    if(this.pList.picklist_items[d].product_code == data[d].product_code)
                    {
                        this.pList.picklist_items[d].qty_picked = data[d].qty_picked
                    }
                }
                for (let key in this.pList.picklist_items)
                {
                    for (let x in this.pList.packlists)
                    {
                        for (let n in this.pList.packlists[x].items)
                        {
                            if (this.pList.picklist_items[key].product_code == this.pList.packlists[x].items[n].product_code)
                            {
                                var item = this.pList.picklist_items[key]
                                item.qty_picked = item.qty_picked * 1
                                
                                item.qty_picked = item.qty_picked + this.pList.packlists[x].items[n].qty_allocated
                                item.qty_balance = item.qty - item.qty_picked
                            }
                        }
                    }
                }

            })
        },
        hideModal () 
        {
            this.$refs.myModalRef.hide()
            location.reload()
        },
        confirmGenerateDO()
        {
            this.modalShow = true
        },
        generateDO()
        {
            this.showGenerateDo = false
            this.loading = true
            var sum = 0
            for (let key in this.pList.packlists)
            {
                var eachDo = this.pList.packlists[key]
                for(let i in eachDo.items)
                {
                    sum = sum + eachDo.items[i].qty_allocated
                }
            }
            if(sum > 0)
            {
                axios.post(apiGenerateDO, {picking_list:this.pList},authHeader())
                    .then (response => {
                        if(response.data.code == 1)
                        {
                            this.loading = false
                            this.showGenerateDo = true
                            this.$refs.myModalRef.show()
                        }
                })
            }
            else
            {
                this.loading = false
                this.showGenerateDo = true
                this.modalShow = false
                this.errorMessage = "Invalid Entry in Do Items"
                this.$refs.myErrorModalRef.show()
            }
        },
        printDO(item)
        {
            var do_num = item.do_num
            var do_item_row = []
            var doItems = []
            do_item_row = [
                {text: 'S/No', style: 'itemsHeader'}, 
                {text: 'Product Code', style: ['itemsHeader'],alignment: 'left'}, 
                {text: 'Product Name', style: ['itemsHeader'],alignment: 'left'}, 
                {text: 'Qty', style: ['itemsHeader'], alignment: 'right'}, 
            ]
            doItems.push(do_item_row)
            for (let key in item.items)
            {
                var data = item.items[key]
                do_item_row = [
                    {text: (key * 1) + 1, style:'itemText'}, 
                    {text: data.product_code,style:'itemText'}, 
                    {text: data.product_name, style:'itemText'}, 
                    {text: data.qty, style:'itemNumber'},
                ]
                doItems.push(do_item_row)
            }

            var consignments = []
            var sales_docs = []

            for (var d in item.invoice_nums_list)
            {
                var document_start_char = item.invoice_nums_list[d].substring(0, 2);

                if (document_start_char == "CN")
                {
                    // Consignments
                    consignments.push(item.invoice_nums_list[d])
                }
                else
                {
                    // Sales Invoices
                    sales_docs.push(item.invoice_nums_list[d])
                }

            }

            var consignment_nums = ''
            if(consignments.length == 0)
            {
                consignment_nums = '-'
            }
            else
            {
                for(let a in consignments)
                {
                    if (consignments[a] == consignments[consignments.length -1])
                    {
                        consignment_nums = consignment_nums + consignments[a]
                    }
                    else
                    {
                        consignment_nums = consignment_nums + consignments[a] + " / " 
                    }

                }
            }
            var invoice_nums = ''
            if(sales_docs.length > 0)
            {
                for(let a in sales_docs)
                {
                    if (sales_docs[a] == sales_docs[sales_docs.length -1])
                    {
                        invoice_nums = invoice_nums + sales_docs[a]
                    }
                    else
                    {
                        invoice_nums = invoice_nums + sales_docs[a] + " / " 
                    }

                }
            }
            else
            {
                invoice_nums = "-"
            }

            var tax_invoices_nums = ''
            var tax_invoice_nums_list = []
            
            if(item.tax_invoice_nums_list != null)
            {
                tax_invoice_nums_list = JSON.parse(item.tax_invoice_nums_list)
            }

            if(tax_invoice_nums_list.length > 0)
            {
                for(let t in tax_invoice_nums_list)
                {
                    
                    if (tax_invoice_nums_list[t] == tax_invoice_nums_list[tax_invoice_nums_list.length -1])
                    {
                        tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t]
                    }
                    else
                    {
                        tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t]+ " / " 
                        
                    }
                }
            }
            else
            {
                tax_invoices_nums = "-"
            }
            var addressTitle = ''
            var address = ''
            if(item.delivery_method_name == 'DELIVERY')
            {
                addressTitle = 'Delivery Address'
                address = item.delivery_address
            }
            else(item.delivery_method_name == 'DELIVERY')
            {
                //address = this.pList.from_location_name + ' (' +item.from_location_id + ')'
                addressTitle = 'Pickup Location'
                address = this.pList.from_location_name + ' (' + item.from_location_id + ')'
            }

            var courier_company = '-'
            if(item.courier_company != '')
            {
                courier_company = item.courier_company               
            }

            var delivery_number = '-'
            if(item.delivery_number != '')
            {
                delivery_number = item.delivery_number
            }
            
    var ddHeader =
     {
         columns: [
             [
                 {
                     text: 'ELKEN ' + item.country_name+' DELIVERY ORDER', 
                     style: 'invoiceTitle',
                     width: '*'
                 },
                 {
                   stack: [
                        {
                            columns: [
                                 {
                                     text:'DO #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: item.do_num,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 {
                                        text: '',
                                        style: 'invoiceSubValue',
                                        width: 80
                                },
                                {
                                     text:'DO Date', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: item.do_date,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                                 
                                 ]
                        },
                        {
                            columns: 
                            [
                                {
                                     text:'Picking List #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: item.picklist_num,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                                 {
                                    text: '',
                                    style: 'invoiceSubValue',
                                    width: 80
                                 },
                                 {
                                     text:'From Location', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: item.from_location_id + ' - ' + this.pList.from_location_name,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                            ]
                        },
                        {
                            columns: 
                            [
                                {
                                    text:'Delivery Method', 
                                    style:'invoiceSubTitle',
                                    width: 90
                                     
                                 }, 
                                 {
                                     text: item.delivery_method_name,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                                 {
                                        text: '',
                                        style: 'invoiceSubValue',
                                        width: 80
                                 },
                                 {
                                     text:'Courier Company', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: courier_company,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                            ]
                        },
                        {
                            columns: 
                            [
                                {
                                     text:'Delivery #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: delivery_number,
                                     style:'invoiceSubValue',
                                     width: 100
                                 },
                                 {
                                        text: '',
                                        style: 'invoiceSubValue',
                                        width: 80
                                 },
                                 {
                                     text:'IBO', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: item.old_member_id + ' - '+ item.member_name,
                                     style:'invoiceSubValue',
                                 },
                            ]
                        },
                        {
                            columns: 
                            [
                                 {
                                     text:'Sales Doc #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text:invoice_nums,
                                     style:'invoiceSubValue',
                                 },
                                 
                            ]
                        },
                        {
                            columns: 
                            [
                                 {
                                     text:'Consignments #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text:consignment_nums,
                                     style:'invoiceSubValue',
                                 },
                                 
                            ]
                        },
                        {
                            columns: 
                            [
                                 {
                                     text:'Tax Invoice #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text:tax_invoices_nums,
                                     style:'invoiceSubValue',
                                 },
                                 
                            ]
                        },
                        //tax_invoices_nums
                        {
                            columns: 
                            [
                                 {
                                     text:addressTitle, 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: address,
                                     style:'invoiceSubValue',
                                 },
                                 
                            ]
                        },
                    ]
                 }
             ],
         ],
     }

var dd = {
header: function(pageNumber, pageCount) {
        return {
            margin: [0,10,0,0],
            columns: [
                { text: '', style: 'documentHeaderLeft' },
                { text: '', style: 'documentHeaderCenter' },
                { text: '', style: 'documentHeaderRight' }
                ]
            }}, 
footer: function(pageNumber, pageCount) {
        return {
        margin: [0,0,0,50],
        columns: [
            { text: '', style: 'documentFooterLeft' },
            { text: 'Page ' + pageNumber + " of " + pageCount , style: 'documentFooterCenter' },
            { text: '', style: 'documentFooterRight' }
        ]
    };
},            
 content: [
     ddHeader,
     // Line breaks
     '\n\n',
     {
        layout: 'lightHorizontalLines',
        table: {

         headerRows: 1,
         widths: [25, 68, '*', 80],
         body: doItems
       }, // table
     },   
     {
        columns: [
                    {
                        stack: [
                            { 
                                text: 'Issued By',
                                style:'signaturePlaceholder'
                            },
                            { 
                                text: '_________________________',
                                style:'signaturePlaceholder'
                            },
                            { 
                                text: 'Name  : '+item.created_author_id,
                                style:'signatureName'
                                                    
                            },
                            { 
                                text: 'Date  : ' + '',
                                style:'signatureJobTitle'
                            }
                        ],
                        width: 160
                    }, 
                    {
                        stack: [
                                { 
                                    text: '  ',
                                    style:'signaturePlaceholder'
                                },
                                { 
                                    text: '                      ',
                                    style:'signaturePlaceholder'
                                },
                                { 
                                    text: '  ',
                                    style:'signatureName'
                                },
                                { 
                                    text: '      ',
                                    style:'signatureJobTitle'
                                }
                                ],
                                width: 160
                    }, 
                    {
                        stack: [
                            { 
                                text: 'Received By',
                                style:'signaturePlaceholder'
                            },

                            { 
                                text: '__________________________',
                                style:'signaturePlaceholder'
                            },
                            { 
                                text: 'Name  :',
                                style:'signatureName'
                                
                            },
                            { 
                                text: 'Date  :',
                                style:'signatureJobTitle'
                                
                            }
                            ],
                            width: 160
                    }

            ]
                        },  
 ],
 styles: {
     // Document Header
     documentHeaderLeft: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'left'
     },
     documentHeaderCenter: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'center'
     },
     documentHeaderRight: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'right'
     },
     // Document Footer
     documentFooterLeft: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'left'
     },
     documentFooterCenter: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'center'
     },
     documentFooterRight: {
         fontSize: 10,
         margin: [5,5,5,5],
         alignment:'right'
     },
     // Invoice Title
     invoiceTitle: {
         fontSize: 22,
         bold: true,
         alignment:'left',
         margin:[0,0,0,15]
     },
     // Invoice Details
     invoiceSubTitle: {
         fontSize: 10,
         alignment:'left'
     },
     invoiceSubValue: {
         fontSize: 10,
         alignment:'left'
     },
     // Billing Headers
     invoiceBillingTitle: {
         fontSize: 14,
         bold: true,
         alignment:'left',
         margin:[0,20,0,5],
     },
     // Billing Details
     invoiceBillingDetails: {
         alignment:'left'

     },
     invoiceBillingAddressTitle: {
         margin: [0,7,0,3],
         bold: true
     },
     invoiceBillingAddress: {
         
     },
     // Items Header
     itemsHeader: {
        
        fontSize: 10,
         margin: [0,5,0,5],
         bold: true
     },
     // Item Title
     itemTitle: {
         bold: true,
     },
     itemSubTitle: {
         //italics: true,
         fontSize: 10
     },
     itemText: {
        fontSize: 10,
         margin: [0,5,0,5],
         alignment: 'left',
     },
     itemNumber: {
        fontSize: 10,
         margin: [0,5,0,5],
         alignment: 'right',
     },
     itemTotal: {
        fontSize: 10,
         margin: [0,5,0,5],
         bold: true,
         alignment: 'right',
     },

     // Items Footer (Subtotal, Total, Tax, etc)
     itemsFooterSubTitle: {
         margin: [0,5,0,5],
         bold: true,
         alignment:'right',
     },
     itemsFooterSubValue: {
         margin: [0,5,0,5],
         bold: true,
         alignment:'center',
     },
     itemsFooterTotalTitle: {
         fontSize: 11,
         margin: [0,5,0,5],
         bold: true,
         alignment:'right',
     },
     itemsFooterTotalValue: {
         fontSize: 11,
         margin: [0,5,0,5],
         bold: true,
         alignment:'center',
     },
     signaturePlaceholder: {
         fontSize: 10,
         margin: [0,70,0,0],   
     },
     signatureName: {
        fontSize: 10,
        margin: [0,10,0,0],
        bold: true,
        alignment:'left',
     },
     signatureJobTitle: {
        fontSize: 10,
        margin: [0,20,0,0],
        bold: true,
        alignment:'left',
     },
     notesTitle: {
       fontSize: 10,
       bold: true,  
       margin: [0,50,0,3],
     },
     notesText: {
       fontSize: 10
     },
     center: {
         alignment:'center',
     },
 },
 defaultStyle: {
     columnGap: 20,
     font:this.font
 }
}
         pdfMake.createPdf(dd).open();
},
printWithoutConsolidatedPickList() 
{
            var picking_list_number = this.picklist_ref
            var row = []
            var pickList_items = []
            var packList =[]
            var dos = this.pList.packlists
            var packingList = []
            for(let d in dos)
            {
                var delivery_address_text = ''
                var delivery_address = ''
                if(dos[d].delivery_method_name == 'DELIVERY')
                {
                    delivery_address_text = "Delivery Address"
                    delivery_address = dos[d].delivery_address
                }
                else
                {
                    delivery_address_text = "Pick-up Location"
                    delivery_address = this.pList.from_location_name + ' (' + this.pList.from_location_id + ')'
                }
                var pHeader = {
                    columns: [
                    [
                        {
                                text: 'INDIVIDUAL PICKING LIST',
                                style: 'invoiceTitle',
                                width: '*'
                        },
                        {
                            stack: [
                            {
                                    columns: 
                                    [
                                        {
                                            text: 'Picking List #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: picking_list_number,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text : ' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Picking List Date',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.picklist_date,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text: ' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Location From',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'IBO / Stockist',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].member_full,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Delivery Method',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].delivery_method_name,
                                            style: 'invoiceSubValue',
                                            width: 100
                                        },
                                    ]
                                },
                                {
                                    text: ' '
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Sales Doc #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].invoice_num_list,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Tax Invoices #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].tax_invoices_nums,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: [
                                        {
                                            text: delivery_address_text,
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text:delivery_address,
                                            style: 'invoiceSubValue',
                                            with: 'auto'
                                        },
                                    ],
                                    
                                }
                            ]
                        }
                    ],
                ],
        }
                var do_items = []
                var data = []
                data = [{
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'SKU',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Product Name',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Qty Delivered',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Qty Balance',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                ]
                do_items.push(data)
                var do_items_format = []
                var dois = dos[d].items
                packingList.push(pHeader) 
                packingList.push('\n\n')
                for(let k in dois)
                {
                    data = [
                        {
                            text:(k*1)+1,
                            style: 'itemText'
                        },
                        {
                            text:dois[k].product_code,
                            style:'itemText'
                        },
                        {
                            text:dois[k].product_name,
                            style:'itemText'
                        },
                        {
                            text:dois[k].qty,
                            style:'itemNumber'
                        },
                        {
                            text:dois[k].qty_delivered,
                            style:'itemText',
                            alignment:'right'
                        },
                        {
                            text:dois[k].qty - dois[k].qty_delivered,
                            style:'itemText',
                            alignment:'right'
                        }

                        ]
                        do_items.push(data)

                            if(d == (dos.length-1))
                            {
                                do_items_format = 
                                {
                                    layout: 'lightHorizontalLines',
                                        table: {
                                            headerRows: 1,
                                            widths: [25, 60, '*', 65, 70, 75],
                                            body: do_items,  
                                        },
                                }
                            
                            }
                            else
                            {
                                do_items_format = 
                                {
                                    layout: 'lightHorizontalLines',
                                        table: {
                                            headerRows: 1,
                                            widths: [25, 60, '*', 65, 70, 75],
                                            body: do_items
                                        },
                                    pageBreak: 'after',
                                }
                            }
  
                    
                }
                packingList.push(do_items_format)
                
            }
            var dd = {
                header: function (pageNumber, pageCount) {
                    return {
                        margin: [0, 20, 0, 0],
                        columns: [{
                                text: '',
                                style: 'documentHeaderLeft'
                            },
                            {
                                text: picking_list_number,
                                style: 'documentHeaderCenter'
                            },
                            {
                                text: '',
                                style: 'documentHeaderRight'
                            }
                        ]
                    }
                },
                footer: function (pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 30],
                        columns: [{
                                text: '',
                                style: 'documentFooterLeft'
                            },
                            {
                                text: 'Page ' + pageNumber + " of " + pageCount,
                                style: 'documentFooterCenter'
                            },
                            {
                                text: '',
                                style: 'documentFooterRight'
                            }
                        ]
                    };
                },
                 // [left, top, right, bottom]
                content: [
                    packingList,
                    {
                                columns: [
                                        {
                                            stack: [
                                                { 
                                                    text: 'Issued By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  : '+ this.pList.author_user_shortname,
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  : ' + this.pList.picklist_date,
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: '  ',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '                      ',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: '  ',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: '      ',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 180
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: 'Picked By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  :',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        }, 
       
                ],
                styles: {
                    // Document Header
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Document Footer
                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Invoice Title
                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },
                    // Invoice Details
                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left',
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left',
                    },
                    // Billing Headers
                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5],
                    },
                    // Billing Details
                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {

                    },
                    // Items Header
                    itemsHeader: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },
                    // Item Title
                    itemTitle: {
                        bold: true,
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left',
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right',
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0],
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left',
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left',
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3],
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center',
                    },
                },
                defaultStyle: {
                    columnGap: 20,
                    font:this.font
                }
            }
            pdfMake.createPdf(dd).open();
        },
        printWithConsolidatedPickList() 
        {
        
            var picking_list_number = this.picklist_ref
            var row = []
            var pickList_items = []
            row = [{
                    text: 'S/No',
                    style: 'itemsHeader'
                },
                {
                    text: 'Product Code',
                    style: ['itemsHeader'],
                    alignment: 'left'
                },
                {
                    text: 'Product Name',
                    style: ['itemsHeader'],
                    alignment: 'left'
                },
                {
                    text: 'Qty',
                    style: ['itemsHeader'],
                    alignment: 'right'
                },
                {
                    text: 'Qty Picked',
                    style: ['itemsHeader'],
                    alignment: 'right'
                },
                {
                    text: 'Balance Qty To Pick',
                    style: ['itemsHeader'],
                    alignment: 'right'
                },
            ]
            pickList_items.push(row)

            for (let key in this.pList.picklist_items) {
                var data = this.pList.picklist_items[key]
                row = [
                    {
                        text: (key * 1) + 1,
                        style: 'itemText'
                    },
                    {
                        text: data.product_code,
                        style: 'itemText'
                    },
                    {
                        text: data.product_name,
                        style: 'itemText'
                    },
                    {
                        text: data.qty,
                        style: 'itemNumber'
                    },
                    {
                        text: data.qty_picked,
                        style: 'itemNumber'
                    },
                    {
                        text: data.qty_balance,
                        style: 'itemNumber'
                    }
                ]
                pickList_items.push(row)
            }
        var pack_lists = this.pList.packlists
        var member_and_delivery = ''
       // alert(pack_lists.length)
  
        for (var p in pack_lists)
        {
            if (p == pack_lists.length - 1)
            {
                member_and_delivery = member_and_delivery + pack_lists[p].member_full + " (" + pack_lists[p].delivery_method_name + ")"  
            }
            else
            {
                member_and_delivery = member_and_delivery + pack_lists[p].member_full + " (" + pack_lists[p].delivery_method_name + ")"  + ", "
            }
               
        }

        var consignment_nums = "-"
        if (this.pList.consignment_nums != '')
        {
            consignment_nums =  this.pList.consignment_nums
        }

        var sales_invoice_nums = '-'
        if (this.pList.sales_invoice_nums != '')
        {
            sales_invoice_nums = this.pList.sales_invoice_nums
        }
        
        var tax_invoices_nums = '-'
        if(this.pList.tax_invoices_nums != '')
        {
            tax_invoices_nums = this.pList.tax_invoices_nums
        }
            var ddHeader = {
                columns: [
                    [{
                            text: 'ELKEN CONSOLIDATED PICKING LIST',
                            style: 'invoiceTitle',
                            width: '*'
                        },
                        {
                            stack: [{
                                    columns: [
                                        {
                                            text: 'Picking List #',
                                            style: 'invoiceSubTitle',
                                            width: 100
                                        },
                                        {
                                            text: this.picklist_ref,
                                            style: 'invoiceSubValue',
                                            width: 84

                                        },
                                        {
                                            text: '',
                                            style: 'invoiceSubValue',
                                            width: 80
                                        },
                                        {
                                            text: 'Picking List Date',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.picklist_date,
                                            style: 'invoiceSubValue',
                                            width: 100

                                        },

                                    ]
                                },
                                {
                                    columns: [{
                                            text: 'Location From',
                                            style: 'invoiceSubTitle',
                                            width: 100

                                        },
                                        {
                                            text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                                            style: 'invoiceSubValue',
                                            width: 84

                                        },
                                        {
                                            text: '',
                                            style: 'invoiceSubValue',
                                            width: 80
                                        },
                                        {
                                            text: 'Status',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.picklist_status,
                                            style: 'invoiceSubValue',
                                            width: 100

                                        },

                                    ]
                                },
                                {
                                    columns: [{
                                            text: 'Sales Docs #',
                                            style: 'invoiceSubTitle',
                                            width: 100

                                        },
                                        {
                                            //123
                                            text: sales_invoice_nums,
                                            style: 'invoiceSubValue',
                                            width: '*'
                                        },
                                        
                                    ]
                                },
                                {
                                    text: '',
                                    style: 'invoiceSubValue',
                                    width: 80
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Consignments #',
                                            style: 'invoiceSubTitle',
                                            width: 100

                                        },
                                        {
                                            //123
                                            text: consignment_nums,
                                            style: 'invoiceSubValue',
                                            width: '*'

                                        },
                                        
                                    ]
                                },
                                {
                                    text: '',
                                    style: 'invoiceSubValue',
                                    width: 80
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Tax Invoices #',
                                            style: 'invoiceSubTitle',
                                            width: 100

                                        },
                                        {
                                            //123
                                            text:tax_invoices_nums,
                                            style: 'invoiceSubValue',
                                            width: '*'

                                        },
                                        
                                    ]
                                },
                                {
                                    text: '',
                                    style: 'invoiceSubValue',
                                    width: 80
                                },
                                {
                                    columns: [
                                        {
                                            text: 'IBO / Stockist',
                                            style: 'invoiceSubTitle',
                                            width: 100

                                        },
                                        {
                                            text: member_and_delivery,
                                            style: 'invoiceSubValue',
                                            width: '*'

                                        },
                                        
                                    ]
                                },


                            ]
                        }
                    ],
                ],
            }
            var packList =[]
            var dos = this.pList.packlists
            var packingList = []
            for(let d in dos)
            {
                var delivery_address_text = ''
                var delivery_address = ''
                if(dos[d].delivery_method_name == 'DELIVERY')
                {
                    delivery_address_text = "Delivery Address"
                    delivery_address = dos[d].delivery_address
                }
                else
                {
                    delivery_address_text = "Pick-up Location"
                    delivery_address = this.pList.from_location_name + ' (' + this.pList.from_location_id + ')'
                }
                var pHeader = {
                    columns: [
                    [
                        {
                            pageBreak: 'before',
                            text: 'INDIVIDUAL PICKING LIST',
                            style: 'invoiceTitle',
                            width: '*'
                        },
                        {
                            stack: [
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Picking List #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: picking_list_number,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text : ' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Picking List Date',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.picklist_date,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text: ' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Location From',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'IBO / Stockist',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].member_full,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: 
                                    [
                                        {
                                            text: 'Delivery Method',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].delivery_method_name,
                                            style: 'invoiceSubValue',
                                            width: 100
                                        },
                                    ]
                                },
                                {
                                    text: ' '
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Sales Doc #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].invoice_num_list,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Tax Invoices #',
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text: dos[d].tax_invoices_nums,
                                            style: 'invoiceSubValue',
                                        },
                                    ]
                                },
                                {
                                    text:' '
                                },
                                {
                                    columns: [
                                        {
                                            text: delivery_address_text,
                                            style: 'invoiceSubTitle',
                                            width: 90

                                        },
                                        {
                                            text:delivery_address,
                                            style: 'invoiceSubValue',
                                            with: 'auto'
                                        },
                                    ]
                                }
                            ]
                        }
                    ],
                ],
        }
                var do_items = []
                var data = []
                data = [{
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'Product Code',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Product Name',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Qty Delivered',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Qty Balance',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                ]
                do_items.push(data)
                var do_items_format = []
                var dois = dos[d].items
                packingList.push(pHeader) 
                packingList.push('\n\n')

                for(let k in dois)
                {
                    data = [
                        {
                            text:(k*1)+1,
                            style: 'itemText'
                        },
                        {
                            text:dois[k].product_code,
                            style:'itemText'
                        },
                        {
                            text:dois[k].product_name,
                            style:'itemText'
                        },
                        {
                            text:dois[k].qty,
                            style:'itemNumber'
                        },
                        {
                            text:dois[k].qty_delivered,
                            style:'itemNumber',
                            alignment:'right'
                        },
                        {
                            text:dois[k].qty - dois[k].qty_delivered,
                            style:'itemNumber',
                            alignment:'right'
                        }

                        ]
                        do_items.push(data)
                        do_items_format = 
                        {
                            layout: 'lightHorizontalLines',
                                table: {
                                    headerRows: 1,
                                    widths: [25, 60, '*', 65, 70, 75],
                                    body: do_items
                                },
                        }
                    
                }
                packingList.push(do_items_format)
            }
            var dd = {
                header: function (pageNumber, pageCount) {
                    return {
                        margin: [0, 20, 0, 0],
                        columns: [{
                                text: '',
                                style: 'documentHeaderLeft'
                            },
                            {
                                text: picking_list_number,
                                style: 'documentHeaderCenter'
                            },
                            {
                                text: '',
                                style: 'documentHeaderRight'
                            }
                        ]
                    }
                },
                footer: function (pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 30],
                        columns: [{
                                text: '',
                                style: 'documentFooterLeft'
                            },
                            {
                                text: 'Page ' + pageNumber + " of " + pageCount,
                                style: 'documentFooterCenter'
                            },
                            {
                                text: '',
                                style: 'documentFooterRight'
                            }
                        ]
                    };
                },
                 // [left, top, right, bottom]
                content: [
                    ddHeader,
                    // Line breaks
                    '\n\n', 
                    {
                        layout: 'lightHorizontalLines',
                        table: {

                            headerRows: 1,
                            widths: [25, 68, '*', 45, 80, 80],
                            body: pickList_items
                        }, // table
                        //pageBreak: 'after'
                    },
    /*              packingList,
                    {
                                columns: [
                                        {
                                            stack: [
                                                { 
                                                    text: 'Issued By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  : '+ this.pList.author_user_id,
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  : ' + this.pList.picklist_date,
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: '  ',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '                      ',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: '  ',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: '      ',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 180
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: 'Picked By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  :',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        }, */
                        {
	        columns: [
	            {
	                stack: [
                        { 
	                        text: 'Issued By',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '____________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: 'Name  :'+ this.pList.author_user_shortname,
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: 'Date  :'+ this.pList.picklist_date,
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },
                {
	                stack: [
                        { 
	                        text: '         ',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '                           ',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '          ' ,
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: ' ',
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },
	            {
	                stack: [
                        { 
	                        text: 'Picked By',
	                        style:'signaturePlaceholder'
	                    },

	                    { 
	                        text: '______________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: 'Name  :',
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: 'Date  :',
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },                
	        ]
	    },
       
                ],
                styles: {
                    // Document Header
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Document Footer
                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Invoice Title
                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },
                    // Invoice Details
                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left',
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left',
                    },
                    // Billing Headers
                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5],
                    },
                    // Billing Details
                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {

                    },
                    // Items Header
                    itemsHeader: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },
                    // Item Title
                    itemTitle: {
                        bold: true,
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left',
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right',
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0],
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left',
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left',
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3],
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center',
                    },
                },
                defaultStyle: {
                    columnGap: 20,
                    font:this.font
                }
            }
            pdfMake.createPdf(dd).open();
        },
    }
}
</script>
<style>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
}
.main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
.checkContainer {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  background-color: #C0C0C0;
}

/* On mouse-over, add a grey background color */
.checkContainer:hover input ~ .checkmark {
  background-color: #ffffff;
}

/* When the checkbox is checked, add a blue background */
.checkContainer input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkContainer input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.checkContainer .checkmark:after {
  left: 7px;
  top: 4px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/views/wsi/picklistinfo.vue